import {TFunction} from "i18next";
import {z} from "zod";
import dayjs, {Dayjs} from "dayjs";
import {CropCycle} from "../types/domain/cropCycle";

export interface FieldCreateFormInputType {
    name: string;
    soilId: string;
    irrigationTypeId: string;
    farmId: string | null;
    orderId: string | null;

    cropCycles: CropCycle[];

    priority: boolean;
    irrigationInterval: number | null;
    desiredMoistureLevel: number | null;
    irrigationCriteria: number | null;
    irrigationDefault: number | null;
    satSoilMoistBias: number | null;
    KSATBias: number | null;
    onFarmEfficiencyMin: number | null;
    minAppliedWater: number | null;
    maxAppliedWater: number | null;
}

export const getCropCycleSchema = (t: TFunction<"translation", undefined>) => {
    return z.object({
        id: z.any().nullable().optional(),
        cropId: z
            .string()
            .nullable()
            .refine((val) => val !== null, {
                message: t("defaults.validation.field_required_error"),
            }),
        variety: z.string(),
        plantedDate: z.instanceof(dayjs as unknown as typeof Dayjs),
        estHarvestDate: z.instanceof(dayjs as unknown as typeof Dayjs).nullable(),
        effRootDepth: z.number().min(0).max(1).nullable().optional(),
        droughtSensitivity: z.number().min(1).max(5).nullable().optional(),
        resetCropCycle: z.boolean().optional(),
        resetETAppliedWater: z.boolean().optional(),
        resetRootDepth: z.boolean().optional(),
    });
};

export const getFieldCreateSchema = (t: TFunction<"translation", undefined>) => {
    return z.object({
        name: z.string().min(1),
        soilId: z.string(),
        irrigationTypeId: z.string(),
        farmId: z.string().nullable(),
        orderId: z
            .string()
            .nullable()
            .refine((val) => val !== null, {
                message: t("defaults.validation.field_required_error"),
            }),
        priority: z.boolean(),
        irrigationInterval: z.number().min(1).max(8).nullable().optional(),
        desiredMoistureLevel: z.number().min(0).max(1).nullable(),
        irrigationCriteria: z.number().min(0).max(1).nullable(),
        irrigationDefault: z.number().min(0).max(100).nullable(),
        satSoilMoistBias: z.number().min(0).max(2).nullable(),
        KSATBias: z.number().min(0).max(2).nullable(),
        cropCycles: z.array(getCropCycleSchema(t)),
        onFarmEfficiencyMin: z.number().min(0).max(1).nullable(),
        minAppliedWater: z.number().int().min(0).nullable(),
        maxAppliedWater: z.number().int().min(0).nullable(),
    });
};
